// src/store/slices/layoutSlice.js
import { createSlice } from '@reduxjs/toolkit'

// A `size` is always `{ height }`; `null` height means "not laid out in this mode"
// (the component either doesn't render or is sized by CSS, e.g. the DESKTOP grid).
const emptySizes = () => ({
  header: { height: null },
  lastCrashMultipliers: { height: null },
  canvas: { height: null },
  jackpot: { height: null },
  bettingPanel: { height: null },
  activityPanel: { height: null },
})

const initialState = {
  mode: 'DESKTOP', // 'DESKTOP' | 'TABLET' | 'MOBILE' | 'MINI'

  duelBetMode: {
    classic: false,
    freebets: false,
    divider: false,
  },

  dimensions: {
    vw: 0,
    vh: 0,
    gap: 0,
    sizes: emptySizes(),
  },
}

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setLayout: (state, action) => {
      const { mode, duelBetMode, dimensions } = action.payload
      if (mode !== undefined) state.mode = mode
      if (duelBetMode !== undefined) state.duelBetMode = duelBetMode
      if (dimensions !== undefined) state.dimensions = dimensions
    },

    setMode: (state, action) => {
      state.mode = action.payload
    },

    setDuelBetMode: (state, action) => {
      state.duelBetMode = action.payload
    },

    resetLayout: () => initialState,
  },
})

export const { setLayout, setMode, setDuelBetMode, resetLayout } = layoutSlice.actions

// ---- Selectors ----
export const selectMode = (state) => state.layout.mode
export const selectDuelBetMode = (state) => state.layout.duelBetMode
export const selectDimensions = (state) => state.layout.dimensions
export const selectCanvasHeight = (state) => state.layout.dimensions.sizes.canvas.height
export const selectBetPanelHeight = (state) => state.layout.dimensions.sizes.bettingPanel.height
export const selectHeaderHeight = (state) => state.layout.dimensions.sizes.header.height

export default layoutSlice.reducer
